// TODO : Description Jadiin 2
// TODO : Still HARDCODE Transaction Type
<style>
    .large-popup .vs-popup {
        width: 1000px;
    }
</style>
<template>
    <div v-if="ready">
        <vs-card class="p-4">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Stock Transfer Details</h4>
                </div>
                <div class="flex items-center">
                <vs-button
                    color="primary"
                    class="btn mb-4 md:mb-0 mr-1"
                >Save</vs-button>
                <vs-dropdown vs-trigger-click>
                    <vs-button class="btn mb-4 md:mb-0 mr-1">Process</vs-button>
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="pickMovement"> Pick Movement </vs-dropdown-item>
                        <vs-dropdown-item @click="putMovement"> Put Movement </vs-dropdown-item>
                        <vs-dropdown-item divider @click="confirmMovement"> Confirm Movement </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transfer ID*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.stock_transfer.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.stock_transfer.reference" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Posting Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.stock_transfer.posting_date" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transaction Type*
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                                <vs-input
                                    class="w-full"
                                    v-model="data.stock_transfer.type"
                                    disabled
                                />
                                <template slot="append">
                                    <div class="append-text btn-addon">
                                        <vs-button
                                            size="small"
                                            color="primary"
                                            icon-pack="feather"
                                            icon="icon-search"
                                            disabled
                                        ></vs-button>
                                    </div>
                                </template>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" disabled v-model="data.stock_transfer.description"/>
                        </div>
                    </div>
                </div>
            </div>
            <vs-tabs class="mt-5">
                <vs-tab label="Item Details" class="pt-base">
                    <vs-table :data="data.stock_transfer_details" hoverFlat class="mt-base">
                        <template slot="thead">
                            <vs-th>Line ID</vs-th>
                            <vs-th>Line Type</vs-th>
                            <vs-th>Warehouse ID</vs-th>
                            <vs-th>Client ID</vs-th>
                            <vs-th>Product ID</vs-th>
                            <vs-th>Description</vs-th>
                            <vs-th>Pack ID</vs-th>
                            <vs-th>Batch</vs-th>
                            <vs-th>Exp. Date</vs-th>
                            <vs-th>Base Qty</vs-th>
                            <vs-th>Base UoM</vs-th>
                            <vs-th>Stock Type</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td>{{ tr.line_id }}</vs-td>
                                <vs-td>{{ tr.line_type }}</vs-td>
                                <vs-td>{{ tr.warehouses_code }}</vs-td>
                                <vs-td>{{ tr.client_code }}</vs-td>
                                <vs-td>{{ tr.product_code }}</vs-td>
                                <vs-td style="max-width: 200px; text-overflow: ellipsis; overflow: hidden;">{{ tr.description_1 }}</vs-td>
                                <vs-td>{{ tr.pack_id }}</vs-td>
                                <vs-td>{{ tr.batch }}</vs-td>
                                <vs-td>{{ tr.expired_date }}</vs-td>
                                <vs-td>{{ tr.base_qty }}</vs-td>
                                <vs-td>{{ tr.base_uom_name }}</vs-td>
                                <vs-td>{{ tr.stock_type_name }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-tab>
                <vs-tab label="Notes" class="pt-base">
                    <vs-textarea label="Note" height="200" v-model="data.note" :disabled="!editMode"/>
                </vs-tab>
                <vs-tab label="Attachment" class="pt-base">
                    <vs-row class="w-full">
                        <vs-button class="mr-4" type="border">Add</vs-button>
                        <vs-button class="mr-4" type="border">Remove</vs-button>
                    </vs-row>
                </vs-tab>
            </vs-tabs>
        </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: {},
            editMode: false,
            ready: false
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        back() {
            this.$router.push({name: 'stock-transfer'})
        },
        fetchData() {
            this.isLoading = true
            this.$http.get('inventories/stocktransfer/show/' + this.$route.params.id)
            .then(res => {
                this.isLoading = false
                this.data = res.data
                this.ready = true
            })
            .catch(error => this.handleError(error))
        },
        putMovement() {
            this.isLoading = true
            this.$http.get('master/locations/filter/available')
            .then(locations => {
                const locationOption = locations.data.map(item => {
                    return {
                        value: item.id,
                        text: item.location_code
                    }
                })

                this.$http.post('inventories/stocktransfer/process/put', { id: this.$route.params.id })
                .then(res => {
                    this.isLoading = false
                    setTimeout(() => {
                        this.$router.push({ name: 'stock-transfer-put', params: { id: this.$route.params.id, data: res.data, locations: locationOption, header: this.data.stock_transfer } })
                    }, 300)
                })
                .catch(err => this.handleError(err))
            })
            .catch(error => this.handleError(error))
        },
        pickMovement() {
            this.isLoading = true
            this.$http.post('inventories/stocktransfer/process/pick', { id: this.$route.params.id })
            .then(res => {
                this.isLoading = false
                setTimeout(() => {
                    this.$router.push({ name: 'stock-transfer-pick', params: { id: this.$route.params.id, data: res.data.pick_movement, header: this.data.stock_transfer } })
                }, 300)
            })
            .catch(error => {
                this.isLoading = false
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: message
                })
            })
        },
        confirmMovement() {
            this.confirmMo({
                transaction_source: this.$route.params.id, transaction_types: ['ST']
            })
            .then(() => this.fetchData())
            .catch(error => this.handleError(error))
        }
    },
    mounted() {
        this.fetchData()
    }
};
</script>